var scope_0 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3ab4d9e39c76af340a113ba917e0506d.js').default;
var scope_1 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95d9a69e0222b08a9559428799092c19.js').default;
var scope_2 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a12940b9fcb6bdafcd3a0aab26835459.js').default;
var scope_3 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a25ee5ffef97a3ecaf640c4038f42340.js').default;
var scope_4 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/bb371b604cd58d6bdc41f05f30d23fb7.js').default;
var scope_5 = require('/opt/build/repo/site/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/dd531b7a7fa8a8f6c45fcf280e980a1a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    